import { Loader, LoadingOverlay } from "@mantine/core";
import { useSelector } from "react-redux";
import {
  loadingMessageSelector,
  showGlobalLoadingSelector,
} from "../../store/slices/appSlice";

interface ILoaderProps {
  content: string;
  showLoader?: boolean;
}

interface IGlobalLoader {
  showSubLoader?: boolean;
}

const LoaderProps = (props: ILoaderProps) => {
  const { content, showLoader } = props;
  return (
    <div className="LoaderProps">
      <p style={{ fontSize: "1.5rem" }}>{content}</p>
      {showLoader && <Loader color="blue" type="bars" />}
    </div>
  );
};

const GlobalLoader = (props: IGlobalLoader) => {
  const { showSubLoader = false } = props;
  const showGlobalLoading = useSelector(showGlobalLoadingSelector);
  const loadingMessage = useSelector(loadingMessageSelector);

  return (
    <div>
      <LoadingOverlay
        visible={showGlobalLoading}
        overlayProps={{
          radius: "sm",
          blur: 2,
        }}
        loaderProps={{
          children: (
            <LoaderProps showLoader={showSubLoader} content={loadingMessage} />
          ),
        }}
      />
    </div>
  );
};

export default GlobalLoader;
